import { render, staticRenderFns } from "./Up.vue?vue&type=template&id=d9d02846&scoped=true&"
import script from "./Up.vue?vue&type=script&lang=js&"
export * from "./Up.vue?vue&type=script&lang=js&"
import style0 from "./Up.vue?vue&type=style&index=0&id=d9d02846&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d02846",
  null
  
)

export default component.exports